import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaBars,
  FaTimes,
  FaHome,
  FaProjectDiagram,
  FaBriefcase,
  FaAward,
  FaCode,
  FaEnvelope,
  FaRobot
} from 'react-icons/fa';
import './Navbar.css';

const Navbar = ({ detailPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll, { passive: true });
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);

    if (location.pathname !== '/') {
      // Navigate to home, then scroll after load
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = [
    { id: 'home', label: 'Home', icon: FaHome },
    { id: 'projects', label: 'Projects', icon: FaProjectDiagram },
    { id: 'ai-projects', label: 'AI Projects', icon: FaRobot },
    { id: 'experience', label: 'Experience', icon: FaBriefcase },
    { id: 'certifications', label: 'Certifications', icon: FaAward },
    { id: 'skills', label: 'Skills', icon: FaCode },
    { id: 'contact', label: 'Contact', icon: FaEnvelope },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div
          className={`navbar-logo ${isScrolled ? 'scrolled' : ''}`}
          onClick={() => scrollToSection('home')}
        >
          <img src="/logos/selfie.jpg" alt="Affan Burney" className="navbar-avatar" />
          <span className="navbar-logo-text">Affan Burney</span>
        </div>
        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''} ${isScrolled ? 'scrolled' : ''}`}>
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                {item.id === 'contact' ? (
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.id);
                    }}
                    className={`navbar-contact-btn ${isScrolled ? 'icon-only' : ''}`}
                    aria-label={item.label}
                  >
                    <Icon className="navbar-icon" />
                    <span className="navbar-label">{item.label}</span>
                  </a>
                ) : (
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.id);
                    }}
                    aria-label={item.label}
                  >
                    <Icon className="navbar-icon" />
                    <span className="navbar-label">{item.label}</span>
                  </a>
                )}
              </li>
            );
          })}
        </ul>
        <div className="navbar-actions">
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
